import React, { useEffect } from 'react';

import Sidebar from './Sidebar'//import $ from "jquery";

import { Link } from 'react-router-dom';

import Barside from '../assets/img/Icons/Icons/Icon-17.png'
import Image1 from '../assets/img/Icons/Icons/msg.png'

import Image2 from '../assets/img/Icons/Icons/imageC2.png'
import Image3 from '../assets/img/Icons/Icons/imageC3.png'
import Image4 from '../assets/img/Icons/Icons/imageC4.png'

import Imageb1 from '../assets/img/Icons/Icons/bagde-hero.png'


import Imgcard1 from '../assets/img/Icons/Icons/cameraI.jpg'
import RedL from '../assets/img/Icons/Icons/sm-barcode.png'


import MainImgSmall from '../assets/img/Icons/Icons/smallimgicon.png'

import LPin from '../assets/img/Icons/Icons/Lpin.png'
import Footer from '../pages/footer'
const Messages = () => {


    // useEffect(() => {
    //     window.scrollTo(0, 0)
    // }, [])


    return (
        <div>
            <div className="bg-white border shadow  bg-bottom-round">
                <div className="container page17">
                    <div className="row mt-3">

                        <div className="col-sm-1-my17 ">
                            <Sidebar/>
                        </div>
                        <div className="col-sm-11-my17 text-center ">
                            <h5 className=" signin1-h1-top  mb-0">Messages</h5>
                        </div>



                    </div>

                    <div className="row ">
                        <div className="col-sm-12 py-2">
                            <hr className="mt-2" />
                            <div>
                                <div className="row    scroll-inner">
                                    <div className="col-sm-12 mt-3">
                                        <a href="" className="text-decoration-none " data-toggle="modal" data-target="#exampleModal">
                                            <div className="d-flex">
                                                <div className="circle-outer my-auto">
                                                    <img src={Image1} alt="" className="circle-inner" />

                                                </div>
                                                <div className="w-80 ml-2">
                                                    <p className="my-auto text-dark mb-0"><small className="font-weight-bold">Subject</small>
                                                    </p>
                                                    <p className="text-dark font12-message mb-0">Lorem ipsum dolor sit amet adipisicing elit. Eveniet ipsam aliquam eligendi magni </p>
                                                </div>
                                                <p className="float-right ">
                                                    <span className=" font12-message bg-light-st">7:30AM</span>
                                                </p>

                                            </div>
                                        </a>
                                    </div>

                                    <div className="col-sm-12 mt-3">
                                        <a href="" className="text-decoration-none " data-toggle="modal" data-target="#exampleModal">
                                            <div className="d-flex">
                                                <div className="circle-outer my-auto">
                                                    <img src={Image1} alt="" className="circle-inner" />

                                                </div>
                                                <div className="w-80 ml-2">
                                                    <p className="my-auto text-dark mb-0"><small className="font-weight-bold">Subject</small>
                                                    </p>
                                                    <p className="text-dark font12-message mb-0">Lorem ipsum dolor sit amet adipisicing elit. Eveniet ipsam aliquam eligendi magni </p>
                                                </div>
                                                <p className="float-right ">
                                                    <span className=" font12-message bg-light-st">7:30AM</span>
                                                </p>

                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-sm-12 mt-3">
                                        <a href="" className="text-decoration-none " data-toggle="modal" data-target="#exampleModal">
                                            <div className="d-flex">
                                                <div className="circle-outer my-auto">
                                                    <img src={Image1} alt="" className="circle-inner" />

                                                </div>
                                                <div className="w-80 ml-2">
                                                    <p className="my-auto text-dark mb-0"><small className="font-weight-bold">Subject</small>
                                                    </p>
                                                    <p className="text-dark font12-message mb-0">Lorem ipsum dolor sit amet adipisicing elit. Eveniet ipsam aliquam eligendi magni </p>
                                                </div>
                                                <p className="float-right ">
                                                    <span className=" font12-message bg-light-st">7:30AM</span>
                                                </p>

                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-sm-12 mt-3">
                                        <a href="" className="text-decoration-none " data-toggle="modal" data-target="#exampleModal">
                                            <div className="d-flex">
                                                <div className="circle-outer my-auto">
                                                    <img src={Image1} alt="" className="circle-inner" />

                                                </div>
                                                <div className="w-80 ml-2">
                                                    <p className="my-auto text-dark mb-0"><small className="font-weight-bold">Subject</small>
                                                    </p>
                                                    <p className="text-dark font12-message mb-0">Lorem ipsum dolor sit amet adipisicing elit. Eveniet ipsam aliquam eligendi magni </p>
                                                </div>
                                                <p className="float-right ">
                                                    <span className=" font12-message bg-light-st">7:30AM</span>
                                                </p>

                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-sm-12 mt-3">
                                        <a href="" className="text-decoration-none " data-toggle="modal" data-target="#exampleModal">
                                            <div className="d-flex">
                                                <div className="circle-outer my-auto">
                                                    <img src={Image1} alt="" className="circle-inner" />

                                                </div>
                                                <div className="w-80 ml-2">
                                                    <p className="my-auto text-dark mb-0"><small className="font-weight-bold">Subject</small>
                                                    </p>
                                                    <p className="text-dark font12-message mb-0">Lorem ipsum dolor sit amet adipisicing elit. Eveniet ipsam aliquam eligendi magni </p>
                                                </div>
                                                <p className="float-right ">
                                                    <span className=" font12-message bg-light-st">7:30AM</span>
                                                </p>

                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-sm-12 mt-3">
                                        <a href="" className="text-decoration-none " data-toggle="modal" data-target="#exampleModal">
                                            <div className="d-flex">
                                                <div className="circle-outer my-auto">
                                                    <img src={Image1} alt="" className="circle-inner" />

                                                </div>
                                                <div className="w-80 ml-2">
                                                    <p className="my-auto text-dark mb-0"><small className="font-weight-bold">Subject</small>
                                                    </p>
                                                    <p className="text-dark font12-message mb-0">Lorem ipsum dolor sit amet adipisicing elit. Eveniet ipsam aliquam eligendi magni </p>
                                                </div>
                                                <p className="float-right ">
                                                    <span className=" font12-message bg-light-st">7:30AM</span>
                                                </p>

                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-sm-12 mt-3">
                                        <a href="" className="text-decoration-none " data-toggle="modal" data-target="#exampleModal">
                                            <div className="d-flex">
                                                <div className="circle-outer my-auto">
                                                    <img src={Image1} alt="" className="circle-inner" />

                                                </div>
                                                <div className="w-80 ml-2">
                                                    <p className="my-auto text-dark mb-0"><small className="font-weight-bold">Subject</small>
                                                    </p>
                                                    <p className="text-dark font12-message mb-0">Lorem ipsum dolor sit amet adipisicing elit. Eveniet ipsam aliquam eligendi magni </p>
                                                </div>
                                                <p className="float-right ">
                                                    <span className=" font12-message bg-light-st">7:30AM</span>
                                                </p>

                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-sm-12 mt-3">
                                        <a href="" className="text-decoration-none " data-toggle="modal" data-target="#exampleModal">
                                            <div className="d-flex">
                                                <div className="circle-outer my-auto">
                                                    <img src={Image1} alt="" className="circle-inner" />

                                                </div>
                                                <div className="w-80 ml-2">
                                                    <p className="my-auto text-dark mb-0"><small className="font-weight-bold">Subject</small>
                                                    </p>
                                                    <p className="text-dark font12-message mb-0">Lorem ipsum dolor sit amet adipisicing elit. Eveniet ipsam aliquam eligendi magni </p>
                                                </div>
                                                <p className="float-right ">
                                                    <span className=" font12-message bg-light-st">7:30AM</span>
                                                </p>

                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-sm-12 mt-3">
                                        <a href="" className="text-decoration-none " data-toggle="modal" data-target="#exampleModal">
                                            <div className="d-flex">
                                                <div className="circle-outer my-auto">
                                                    <img src={Image1} alt="" className="circle-inner" />

                                                </div>
                                                <div className="w-80 ml-2">
                                                    <p className="my-auto text-dark mb-0"><small className="font-weight-bold">Subject</small>
                                                    </p>
                                                    <p className="text-dark font12-message mb-0">Lorem ipsum dolor sit amet adipisicing elit. Eveniet ipsam aliquam eligendi magni </p>
                                                </div>
                                                <p className="float-right ">
                                                    <span className=" font12-message bg-light-st">7:30AM</span>
                                                </p>

                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-sm-12 mt-3">
                                        <a href="" className="text-decoration-none " data-toggle="modal" data-target="#exampleModal">
                                            <div className="d-flex">
                                                <div className="circle-outer my-auto">
                                                    <img src={Image1} alt="" className="circle-inner" />

                                                </div>
                                                <div className="w-80 ml-2">
                                                    <p className="my-auto text-dark mb-0"><small className="font-weight-bold">Subject</small>
                                                    </p>
                                                    <p className="text-dark font12-message mb-0">Lorem ipsum dolor sit amet adipisicing elit. Eveniet ipsam aliquam eligendi magni </p>
                                                </div>
                                                <p className="float-right ">
                                                    <span className=" font12-message bg-light-st">7:30AM</span>
                                                </p>

                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-sm-12 mt-3">
                                        <a href="" className="text-decoration-none " data-toggle="modal" data-target="#exampleModal">
                                            <div className="d-flex">
                                                <div className="circle-outer my-auto">
                                                    <img src={Image1} alt="" className="circle-inner" />

                                                </div>
                                                <div className="w-80 ml-2">
                                                    <p className="my-auto text-dark mb-0"><small className="font-weight-bold">Subject</small>
                                                    </p>
                                                    <p className="text-dark font12-message mb-0">Lorem ipsum dolor sit amet adipisicing elit. Eveniet ipsam aliquam eligendi magni </p>
                                                </div>
                                                <p className="float-right ">
                                                    <span className=" font12-message bg-light-st">7:30AM</span>
                                                </p>

                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-sm-12 mt-3">
                                        <a href="" className="text-decoration-none " data-toggle="modal" data-target="#exampleModal">
                                            <div className="d-flex">
                                                <div className="circle-outer my-auto">
                                                    <img src={Image1} alt="" className="circle-inner" />

                                                </div>
                                                <div className="w-80 ml-2">
                                                    <p className="my-auto text-dark mb-0"><small className="font-weight-bold">Subject</small>
                                                    </p>
                                                    <p className="text-dark font12-message mb-0">Lorem ipsum dolor sit amet adipisicing elit. Eveniet ipsam aliquam eligendi magni </p>
                                                </div>
                                                <p className="float-right ">
                                                    <span className=" font12-message bg-light-st">7:30AM</span>
                                                </p>

                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-sm-12 mt-3">
                                        <a href="" className="text-decoration-none " data-toggle="modal" data-target="#exampleModal">
                                            <div className="d-flex">
                                                <div className="circle-outer my-auto">
                                                    <img src={Image1} alt="" className="circle-inner" />

                                                </div>
                                                <div className="w-80 ml-2">
                                                    <p className="my-auto text-dark mb-0"><small className="font-weight-bold">Subject</small>
                                                    </p>
                                                    <p className="text-dark font12-message mb-0">Lorem ipsum dolor sit amet adipisicing elit. Eveniet ipsam aliquam eligendi magni </p>
                                                </div>
                                                <p className="float-right ">
                                                    <span className=" font12-message bg-light-st">7:30AM</span>
                                                </p>

                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-sm-12 mt-3">
                                        <a href="" className="text-decoration-none " data-toggle="modal" data-target="#exampleModal">
                                            <div className="d-flex">
                                                <div className="circle-outer my-auto">
                                                    <img src={Image1} alt="" className="circle-inner" />

                                                </div>
                                                <div className="w-80 ml-2">
                                                    <p className="my-auto text-dark mb-0"><small className="font-weight-bold">Subject</small>
                                                    </p>
                                                    <p className="text-dark font12-message mb-0">Lorem ipsum dolor sit amet adipisicing elit. Eveniet ipsam aliquam eligendi magni </p>
                                                </div>
                                                <p className="float-right ">
                                                    <span className=" font12-message bg-light-st">7:30AM</span>
                                                </p>

                                            </div>
                                        </a>
                                    </div>



                                </div>
                            </div>







                            <div className="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div className="modal-dialog" role="document">
                                    <div className="modal-content modal-content-message ">

                                        <div className="modal-body">
                                            <div className="text-center">
                                                <div className="circle-outer my-auto text-center mx-auto">
                                                    <img src={Image1} alt="" className="circle-inner text-center" />
                                                </div>
                                                <p className=" "><small>Name</small></p>
                                            </div>

                                            <p className="font12-message-model ">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis, similique laudantium. Iste saepe voluptatum et sunt culpa beatae, reprehenderit, ducimus nisi tempora provident pariatur atque nihil, voluptate molestias temporibus porro.</p>
                                        </div>
                                        <div className="mb-3 text-center">
                                            <button type="button" className="btn btn-outline-danger py-0 w-25 text-center" data-dismiss="modal">Delete</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    )
}

export default Messages;

